import React, { Component } from "react";
import { Button, PageHeader, Col } from "react-bootstrap";
import uniqueId                 from 'lodash/uniqueId';
import config                   from "../../config";
import { Colors }               from "../../utils/Colors";
import { WhiteLabel }           from "../../utils/WhiteLabelProps";
import { invokeGetZoom }        from "../../utils/AwsInvoke";
import "../../css/utils/Settings.css";


var company_id  = sessionStorage.getItem('company_id');
const posture_health_company_id = "69c4ac91-69b7-11ea-b027-a3b6eeba595f";
const asp_company_id            = "9a7af3c4-97b1-11e7-9e5d-f78105fd617e";

export default class SettingHome extends Component {
    constructor(props) {
        super(props);

        this.state = {
          isLoading: true,
        };
    }

    async componentDidMount () {
        if (!this.props.isAuthenticated) {
            return;
        }

        try {
            await this.getZoomSig();

        } catch (e) {
            alert(e);
        }
    }

    getZoomSig = async (event) => {
        var meeting_role = 1; // Meeting Host
        var sig;

        var results = await invokeGetZoom(meeting_role);
        if(results.status) {
            this.setState({
                zoomSig: results.signature,
                meetingId: results.meeting_id,
                meetingPassword: results.meeting_password,
                apiKey: results.api_key
            })

            return sig;
        }
    }

    renderHome() {
        var zoom_sig    = this.state.zoomSig;
        var meeting_id  = this.state.meetingId; //  "9578582317"; // meeting id
        var mp          = this.state.meetingPassword; // "TUYweW9JNEJTdjJVMWJDN3NNNHc1dz09"; // meeting pass
        var api_key     = this.state.apiKey;
        var logo;
        /*console.log("1. zoom_sig: " +  zoom_sig);
        console.log("1. meeting_id: " +  meeting_id);
        console.log("1. meetingPassword: " +  mp);*/

        var zoom_url = "https://zoom.trainingslate.com/"; //"http://127.0.0.1:9999/";

        if(company_id != posture_health_company_id && company_id != asp_company_id)
                zoom_link = "If you don't have a Zoom account, contact us at info@trainingslate.com and we'll help set you up.";

        if(company_id == posture_health_company_id)
            logo = "posture";
        else if(company_id == asp_company_id)
            logo = "asp";

        var zoom_link = <div>
                            <div>
                            </div>
                            <div style={{cursor: "pointer", color: Colors.primary_color}}
                                 onClick={() => window.open(zoom_url + "index.html?type=1&key="+api_key+"&mid="+meeting_id+"&mp="+mp+"&sig="+zoom_sig+"&logo="+logo, "_blank")}
                            >
                                <b>Begin Zoom meeting <span className="glyphicon glyphicon-hand-right" style={{ position:"relative", top:5, paddingLeft:3, fontSize: "1.35em"}}/></b>
                            </div>
                        </div>

        return (
              <div className="programs">
                <PageHeader>
                    <span className="glyphicon glyphicon-facetime-video" style={{ position:"relative", top:5, fontSize: '1em', color: Colors.primary_color, paddingRight:"16px" }}/>
                    Zoom Meeting
                </PageHeader>
                <div>
                    Welcome to the Zoom meeting page.
                    <br/><br/>
                    <div>
                        Meeting Id: <b>{meeting_id}</b>
                    </div>
                    { /*Copy and paste your meeting id into the popup window and your Zoom session will start.*/ }
                    <br/>

                </div>
                <br/>
                {zoom_link}

              </div>
        );
    }

    render() {
        return (
              <div className="Home">
                { this.renderHome() }
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/zoom/Zoom.js